import { TrainingPageData } from "@/types";

export const trainingPageData: TrainingPageData = {
  header: {
    badge: "Training for Public Safety and Military",
    subtitle:
      "Best-in-class training with seasoned professionals in emergency response, public safety, and advanced diving for India’s Military, Paramilitary & Rescue Forces.",
  },
  sections: [
    {
      id: "training-modules",
      badge: "TRAINING MODULES",
      items: [
        { id: "public-safety", title: "Public Safety Diving" },
        { id: "swift-water", title: "Swift Water Rescue Training" },
        { id: "ccr-diving", title: "Closed Circuit Rebreather Diving" },
        { id: "dry-suit-diving", title: "Dry Suit Diving" },
        { id: "dpv-diving", title: "DPV(Diver Propulsion Vehicle) Diving" },
        { id: "emergency-response", title: "Emergency Response & Medic Training Courses" },
        { id: "sos-hyperlite", title: "SOS Hyperlite Hyperbaric Emergency Medical Training Courses" },
        { id: "wilderness-medicine", title: "Wilderness Medicine Training Courses" },
      ],
    },
    {
      id: "civilian-recreational-programs",
      badge: "CIVILIAN/RECREATIONAL TRAINING PROGRAMS",
      items: [
        { id: "deep-diving", title: "Deep Diving - up to 40Mt" },
        { id: "decompression-diving", title: "Decompression Diving" },
        { id: "night-visibility", title: "Night & Limited Visibility Diving" },
        { id: "nitrox-trimix", title: "Nitrox & Trimix Gas Blending" },
        { id: "ccr-training", title: "Closed Circuit Rebreather Training" },
        { id: "dpv-civilian", title: "DPV Diving" },
        { id: "search-recovery", title: "Search & Recovery" },
        { id: "diver-stress-rescue", title: "Diver Stress & Rescue" },
        { id: "react-training", title: "React React Training- First Aid, CPR, AED & O2" },
        { id: "divemaster-training", title: "Divemaster Training" },
        { id: "instructor-training", title: "Instructor Training" },
      ],
    },
  ],
  trainersSection: {
    badge: "TRAINERS",
    trainers: [
      {
        id: "vishwanath-rajan",
        name: "Cdr. Vishwanath Rajan",
        image: "/images/trainers/Cdr Vishwanath Rajan.jpeg",
        sections: [
          {
            title: "1. Leadership & Operations:",
            points: [
              "Former military officer with extensive experience in command, training, and managing high-risk operations.",
              "On-ground experience in planning and executing missions in remote and sub-optimal environments with limited resources.",
              "Instructor in Tactical medicine, Wilderness medicine, and EMS training",
            ],
          },
          {
            title: "2. Emergency Medicine Certifications:",
            points: [
              "Nationally Registered Paramedic (NRP), U.S.",
              "Flight & Critical Care Paramedic (FP-C, CCP)",
              "Wilderness Paramedic (WP-C)",
              "Wildland Fire Paramedic (EMPF)",
              "Diving Medical Technician (DMT), DAN",
              "Diving Emergency Medical Responder Instructor",
              "Fellow of the Academy of Wilderness Medicine (FAWM)",
              "Fellow of the Royal Geographic Society (FRGS)",
            ],
          },
          {
            title: "3. Diving Proficiency:",
            points: [
              "Technical & Public Safety Diving Instructor",
              "Certified Trimix Closed-Circuit Rebreather Diver",
              "OEM (rEvo) approved CCR Trainer since March 2026",
              "Underwater Cave & Wreck Explorer",
              "Various other Specialty Ratings",
            ],
          },
        ],
      },
      {
        id: "rishab-menon",
        name: "Rishab Menon",
        image: "/images/trainers/Rishab Menon.jpeg",
        sections: [
          {
            title: "Diving Proficiency",
            points: [
              "Open Water Instructor since 2017",
              "Certified SSI Assistant Instructor Trainer",
              {
                title: "Specialty Instructor Ratings –",
                subPoints: [
                  "Deep Diving",
                  "Enriched Air Nitrox",
                  "Navigation Diving",
                  "Search and Recovery",
                  "Night & Limited Visibility",
                  "Classified Diving",
                  "DPV Diving",
                  "Perfect Buoyancy",
                  "Photo & Video",
                  "Science of Diving",
                  "Diver Stress and Rescue",
                  "Waves, Tides, & Currents",
                  "Wreck Diving",
                  "Scuba Explorers",
                  "Sidemount Diving",
                  "Extended Range Diving",
                  "Dry Suit Diving",
                ],
              },
              "Gas Blender Nitrox/Trimix Instructor",
              "React Right Instructor",
              "SSI rEvo CCR Diver (30m, Air Diluent, No Decompression) since September 2025",
              "OEM (rEvo) approved CCR Trainer since March 2026",
            ],
          },
        ],
      },
      {
        id: "mrigank-save",
        name: "Mrigank Save",
        image: "/images/trainers/Mrigank Save.jpeg",
        sections: [
          {
            title: "Diving Proficiency",
            points: [
              "Open Water Instructor since 2023",
              "Certified SSI Divemaster Instructor",
              "Certified SSI Dry Suit Diver",
              {
                title: "Specialty Instructor Ratings:",
                subPoints: [
                  "Deep Diving",
                  "Dive Guide",
                  "DPV Diving",
                  "Technical DPV Diving",
                  "Enriched Air Nitrox",
                  "Navigation Diving",
                  "Night & Limited Visibility",
                  "Perfect Buoyancy",
                  "Science of Diving",
                  "Decompression Diving",
                  "Diver Stress and Rescue",
                  "Waves, Tides & Currents",
                  "Computer Diving",
                  "Sidemount (Recreational & Technical)",
                  "Extended Range Diving",
                  "Marine Ecology",
                  "Nudibranch Ecology",
                  "Marine Invertebrate Ecology",
                  "Coral Identification Ecology",
                ],
              },
              "React Right Instructor",
              "SSI rEvo CCR Diver (30m, Air Diluent, No Decompression) since September 2025",
              "OEM (rEvo) approved CCR Trainer since March 2026",
            ],
          },
        ],
      },
    ],
  },
};
